
import Base from './Base';


export default class Trip extends Base {
  // 主要以这个接口的trip结构为准
  // doc: https://doc.oschina.net/xingchengzushou?t=145627
  schema = {
    trip_id: String,
    trip_name: String,
    desc: String, // 目前（v1.1）只有Demo行程才有这个值
    cover_pic: String, // 封面图

    trip_days: Number,
    days: Number, // 不知道有什么用
    start_time: Number, // 秒
    end_time: Number, // 秒
    timezone: Number,
    operate_times: Number,

    start_city: Number,
    end_city: Number,
    start_region: Number,
    end_region: Number,

    pickup: Object, // 取车点
    dropoff: Object, // 还车点

    is_demo: Boolean, // 是否Demo行程
    is_article_trip: Boolean, // 是否文章行程
    is_show: Boolean, // 是否已群人创建
    old_trip_type: Number, // 为了兼容1.0的数据（这个版本别管1.0的数据了）
    has_terminal_point: Boolean,

    share: {
      code: String
    },
    // [{tag_name: String, theme_id: String}]
    tags: Array,

    cross_city_ids: Array, // 途径城市ID（v1.1弃用）

    // 包含每日的poi列表和城市列表
    poi_list: [
      {
        day: Number,
        date: Number,
        timezone: Number,
        // [{poi_uid: String, flag: String}]
        pois: Array,
        // id数组
        cities: Array
      }
    ],

    poi_uid_map: Object, // 完整的poi数据
    city_info_maps: Object, // 完整的城市数据
    region_info_maps: Object // 完整的region对象
  };

  // trip.getList接口
  static parseInput(obj = {}, city_info_maps) {
    let result = {
      trip_id: obj.trip_id,
      trip_name: obj.trip_name,
      cover_pic: obj.cover_pic,

      trip_days: obj.trip_days,
      days: obj.days,
      start_time: obj.start_time,
      end_time: obj.end_time,
      update_time: obj.update_time,

      start_region: obj.pickup_region,
      end_region: obj.dropoff_region,

      share: obj.share,

      country: obj.pickup_region_cn,

      city_list: obj.city_list
    };

    // 先不要这个数据，会出bug（这个city_info_maps并不是行程的city_info_maps）
    // if (city_info_maps) {
    //   result.city_info_maps = city_info_maps;
    // }

    if (obj.start_region && obj.pickup_region_cn) {
      result.region_info_maps || (result.region_info_maps = {});
      result.region_info_maps[obj.start_region] = {
        cn_name: obj.pickup_region_cn
      };
    }

    if (obj.end_region) {
      result.region_info_maps || (result.region_info_maps = {});
      result.region_info_maps[obj.end_region] = {
        cn_name: obj.dropoff_region_cn
      };
    }

    return result;
  }

  // order.getAll();
  static parseInput2(obj) {
    return {
      trip_id: obj.trip_id,
      trip_name: obj.trip_name,
      cover_url: obj.cover_url,
      tags: obj.tags,
      days: obj.days,
      poi_list: obj.poi_list,
      start_city: obj.start_city
    };
  }

  // trip.getOneDemo()
  static parseInput3(obj) {
    return {
      trip_id: obj.trip_id,
      trip_name: obj.title,
      desc: obj.desc,
      cover_pic: obj.bg_img,
      is_demo: true
    };
  }

  // trip.getOneTrip()
  static parseInput4(obj) {
    // 这里把country抽离出来是为了新增行程的时候返回首页便于按国家分类排序
    if (obj.region_info_maps && Object.keys(obj.region_info_maps).length) {
      for (let key in obj.region_info_maps) {
        if (Number(obj.start_region) === Number(key)) {
          obj.country = obj.region_info_maps[key].region_cn;
          break;
        }
      }
    }
    return {
      ...obj,
      cover_pic: obj.trip_img.cover
    };
  }
}




// WEBPACK FOOTER //
// ./src/models/Trip.js